import {
	SET_LOCATION_FILTERS_FULFILLED,
	SET_PRICE_FILTERS_FULFILLED,
	SET_ROOM_COUNT_FILTERS_FULFILLED,
	CLEAR_ALL_FILTERS_FULFILLED
} from '../constants/filters.actions';
import { setFilteredApartments } from './apartmentsActions';

export const setLocationFilters = (filters) => {
	return (dispatch, getState) => {
		const { selectedPrices, selectedRoomCount } = getState().filtersReducer;

		dispatch(setFilteredApartments({
			selectedLocations: filters,
			selectedPrices,
			selectedRoomCount
		}));

		dispatch({
			type: SET_LOCATION_FILTERS_FULFILLED,
			payload: {
				filters
			}
		});
	};
};

export const setPriceFilters = (filters) => {
	return (dispatch, getState) => {
		const { selectedLocations, selectedRoomCount } = getState().filtersReducer;

		dispatch(setFilteredApartments({
			selectedPrices: filters,
			selectedLocations,
			selectedRoomCount
		}));

		dispatch({
			type: SET_PRICE_FILTERS_FULFILLED,
			payload: {
				filters
			}
		});
	};
};


export const setRoomCountFilters = (filters) => {
	return (dispatch, getState) => {
		const { selectedPrices, selectedLocations } = getState().filtersReducer;

		dispatch(setFilteredApartments({
			selectedRoomCount: filters,
			selectedPrices,
			selectedLocations
		}));

		dispatch({
			type: SET_ROOM_COUNT_FILTERS_FULFILLED,
			payload: {
				filters
			}
		});
	};
};

export const clearAllFilters = () => ({
	type: CLEAR_ALL_FILTERS_FULFILLED,
	payload: null
});
